import React, {
  useEffect,
  useState,
  useContext,
  useCallback,
  useRef
} from 'react'
import SignersAndApprovers from './SignersAndApprovers'
import LocationsWidget from './LocationsWidget'
import DeliveryCard from './DeliveryCard'
import ContractDetailWidget from './ContractDetailWidget'
import ContractHistoryWidget from './ContractHistoryWidget'
import FuelDeliveryWidget from './FuelDeliveryWidget'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import { getContractByIdWithInitialField, voidContract, getStewardshipFields, changePhoneAndResend, getHighestRole, syncContract } from '../../../services/apiHelper'
import moment from 'moment'
import {
  handleSigners,
  nullParser,
  convertToSentenceCase,
  enogenUnitsCalculator,
  stringToFloat
} from '../../../services/utils'
import { useParams } from 'react-router-dom'
import { Button } from 'syngenta-react-components'
import { GlobalContext, AuthContext } from '../../../services/context'
import ModalWithStates from '../../../dpe-usco/components/ModalWithStates/ModalWithStates'
import useApiHelper from '../../../services/useApiHelper'
import StewardshipSummary from '../Stewardship/StewardshipSummary'
import SendForSigningForm from '../../../components/ModalForms/SendForSigningForm'

const generateMonthMap = year => {
  const startDate = year ? `${year}-09-01` : new Date().getFullYear() + '-09-01'
  const momentDate = moment(startDate)
  const monthMap = new Map()
  for (let i = 0; i < 13; i++) {
    const newDate = momentDate.clone().add(i, 'month')
    const delivery_month = newDate.format('MMM-YY')
    const month = newDate.format('MMMM').toLowerCase()
    const formattedYear = newDate.format('YYYY')
    monthMap.set(delivery_month, {
      delivery_month,
      month,
      year: formattedYear,
      contracted_units: 0,
      harvested_units: 0,
      delivered_units: 0
    })
  }
  return monthMap
}

const contractDetailSubHeaders = [
  ['Create date', 'created'],
  ['Contract year', 'year'],
  ['Contract type', 'contract_type'],
  ['Grower name', 'grower_name'],
  ['Contracted acres', 'acres'],
  ['Reseller', 'reseller'],
  ['Enogen units', 'enogen_units'],
  ['Grain receiver', 'grain_receiver'],
  ['Total Yield (bushels)', 'total_yield'],
  ['Created in', 'contract_originated']
]


const contractDetailGenericSubHeaders = [
  ['Create date', 'created'],
  ['Contract year', 'year'],
  ['Contract type', 'contract_type'],
  ['Grower name', 'grower_name'],
  ['Contracted acres', 'acres'],
  ['Reseller', 'reseller'],
  ['Units', 'enogen_units'],
  ['Grain receiver', 'grain_receiver'],
  ['Total Yield (bushels)', 'total_yield'],
  ['Created in', 'contract_originated']
]

const FED_ON_FARM = 'fed-on-farm'
const FUEL = 'fuel'

const customToolTipStyle = () => {
  const style = document.createElement('style')
  style.innerHTML = `
    .custom-tooltip {
      position: relative;
      display: inline-block;
    }

    .custom-tooltip[message]:hover::after {
      content: attr(message);
      visibility: visible;
      width: 210px;
      background-color: #555;
      color: #fff;
      text-align: center;
      border-radius: 6px;
      padding: 5px 10px;
      position: absolute;
      z-index: 1;
      top: -60px;
      transform: translateX(-50%);
      opacity: 1;
      transition: opacity 0.3s;
    }

    .custom-tooltip::after {
      content: '';
      position: absolute;
      top: -5px;
      left: 50%;
      margin-left: -5px;
      font-size: 12px;
      border-width: 5px;
      border-style: solid;
      border-color: #555 transparent transparent transparent;
      visibility: hidden;
      opacity: 0;
      transition: opacity 0.3s;
    }
  `
  document.head.appendChild(style)
}

export const ContractDetailView = () => {
  const { state, dispatch, trackEvent } = useContext(GlobalContext)
  const { hasAccess, hasStewardAccess } = useContext(AuthContext)
  const params = useParams()
  const { contract_id, company_id } = params || {}
  const [contractData, setContractData] = useState({})
  const [signersData, setSignersData] = useState([])
  const [contractDetailData, setContractDetailData] = useState({
    created: '',
    year: '',
    contract_type: '',
    grower_name: '',
    acres: '',
    reseller: '',
    enogen_units: '',
    grain_receiver: '',
    total_yield: '',
    new_contract_id: '',
    contract_originated: '',
    contract_history: {}
  })
  const [contractHistoy, setContractHistoy] = useState(null)
  const [growerAndResellerSAP, setGrowerAndResellerSAP] = useState({
    growerSAPId: '',
    resellerSAPId: ''
  })
  const [resellerAndReceiverId, setResellerAndReceiverId] = useState({
    resellerId: '',
    receiverId: ''
  })
  const [contractType, setContractType] = useState()
  const [contractStatus, setContractStatus] = useState('LOADING')
  const [deliveryStatus, setDeliveryStatus] = useState('LOADING')
  const [signersStatus, setSignersStatus] = useState('LOADING')
  const [locationsStatus, setLocationsStatus] = useState('LOADING')
  const [showModal, setShowModal] = useState(false)
  const [showSignersModal, setShowSignersModal] = useState(false)
  const [loadingStatus, setLoadingStatus] = useState(false)
  const [isVoided, setIsVoided] = useState(false)
  const [showRecordStewardship, setShowRecordStewardship] = useState(true)
  const [modifiedDate, setModifiedDate] = useState()
  const [hasPermissions, setHasPermissions] = useState('LOADING')
  const [hasStewardshipPermissions, setHasStewardshipPermissions] = useState(
    'LOADING'
  )
  const [stewardsUsers, setStewardsUsers] = useState([])

  const [modalState, setModalState] = useState('VOID')
  const [companiesArray, setCompaniesArray] = useState([])
  const [deliveryData, setDeliveryData] = useState()
  const [fuelDeliveryTableStatus, setFuelDeliveryTableStatus] = useState('LOADING')

  const [{ data: stewardshipData }, getStewardshipActivities] = useApiHelper('getStewardshipActivities')
  const [{ data: scaleTickets }, getScaleTickets] = useApiHelper('getScaleTickets')
  const [isZeroOut, setIsZeroOut] = useState(false)
  const [isTotalfield, setIsTotalfield] = useState(false)
  const [resendLoading, setResendLoading] = useState()
  const [resendMessage, setResendMessage] = useState('')
  const [userInfo, setUserInfo] = useState({})
  const [isSyncContract, setIsSyncContract] = useState(false)
  const [synBtnTxt, setSynBtnTxt] = useState('Sync contract')

  const canceled = useRef(false)
  useEffect(() => {
    customToolTipStyle()
    return () => {
      canceled.current = true
    }
  }, [])

  const [isAmend, setIsAmend] = useState(false)
  useEffect(() => {
    getHighestRole()?.then(res => {
      if (res.permissions.includes('amend-contract')) {
        setIsAmend(true)
      } else {
        setIsAmend(false)
      }
      setUserInfo(
        {
          voided_user_info: {
            'user_id': res.user_id,
            'user_name': res.first + ' ' + res.last,
            'user_email': res.email,
            'system_name': 'GrowMore360'
          }
        }
      )
      if (res.permissions.includes('sync-contract')) {
        setIsSyncContract(true)
      } else {
        setIsSyncContract(false)
      }
    })
  }, [])

  useEffect(() => {
    const initData = () => {
      const dispatchObj = {
        type: 'SET_CONTRACT_VIEW',
        payload: { title: `${contractDetailData.year}: ${contractDetailData.grower_name} to ${contractDetailData.reseller}`, previous: 'Back' }
      }
      dispatch(dispatchObj)
    }
    if (contractDetailData.reseller && contractDetailData.grower_name && contractDetailData.year)
      initData()
  }, [dispatch, contractDetailData])

  const goToSignContract = e => {
    e.preventDefault()
    const new_contract_id = contractDetailData.new_contract_id
    trackEvent('sign_contract_clicked', {
      contractId: contract_id,
      companyId: company_id
    })
    dispatch({
      type: 'GO_TO_SIGN_CONTRACT',
      payload: { contract_id, company_id, RE_SIGN_MODE: false, new_contract_id }
    })
  }

  const goToResendForSigning = e => {
    e.preventDefault()
    setShowSignersModal(true)
    trackEvent('resend_for_signing_contract_clicked', {
      contractId: contract_id,
      companyId: company_id
    })
  }

  const goToStewardship = e => {
    e.preventDefault()
    const stewardship_activity_id = stewardshipData[0].stewardship_activity_id
    const new_contract_id = contractDetailData.new_contract_id
    trackEvent('record_stewardship_clicked', {
      contractId: contract_id,
      stewardshipActivityId: stewardship_activity_id
    })
    dispatch({
      type: 'GO_TO_STEWARDSHIP_DETAIL',
      payload: { company_id, stewardship_activity_id, new_contract_id }
    })
  }

  const handleClose = args => {
    if (args === 'AMEND') {
      dispatch({
        type: 'GO_TO_VOID_CONTRACT',
        payload: { contract_id, company_id }
      })
    } else {
      setShowModal(false)
    }
  }

  const attemptVoidContract = () => {
    setShowModal(true)
    setModalState('VOID')
    trackEvent('void_contract_attempted', { contractId: contract_id })
  }

  const attemptAmendContract = () => {
    setShowModal(true)
    setModalState('AMEND')
    setLoadingStatus()
    trackEvent('amend_contract_attempted', { contractId: contract_id })
  }

  const actuallyVoidContract = async type => {
    setLoadingStatus('LOADING')
    const new_contract_id = contractDetailData.new_contract_id
    if (type === 'amend') {
      setLoadingStatus()
      dispatch({
        type: 'GO_TO_VOID_CONTRACT',
        payload: { contract_id, company_id, new_contract_id }
      })
    } else {
      trackEvent(`contract_${type}ed`, { contractId: contract_id })
      if (!isVoided) {
        voidContract(contract_id, { ...userInfo, 'voided_from': 'void_action' })?.then(() => {
          setLoadingStatus()
          setIsVoided(true)
          setShowRecordStewardship(false)
          setIsAmend(false)
          callGetContractById()
          setShowModal(false)
        })
      } else {
        setLoadingStatus('SUCCESS')
      }
    }

  }

  const callGetContractById = useCallback(async () => {
    getContractByIdWithInitialField(contract_id)?.then(response => {
      if (response) {
        if (
          response.contract_details?.display_details?.contract_type
        ) {
          setContractType(response.contract_details.display_details.contract_type)
        }
        setContractData(response)
        setContractStatus()
        setCompaniesArray([
          response.contract_details.reseller_details.reseller_id,
          response.contract_details.grain_receiver_details.grain_receiver_id
        ])
        if (response.contract_state === 'voided') {
          setModifiedDate(response.modified)
          setIsVoided(true)
        } else {
          setIsVoided(false)
        }
        if (response.contract_signers) {
          setSignersData(handleSigners(response.contract_signers))
          setSignersStatus()
        } else {
          setSignersStatus('EMPTY')
        }
        if (response.contract_details && response.contract_details.storage) {
          setLocationsStatus()
        } else {
          setLocationsStatus('EMPTY')
        }
        if (
          response?.contract_details?.delivery_schedule?.length ||
          response?.contract_details?.cattle_info.length
        ) {
          setDeliveryStatus()
        } else {
          setDeliveryStatus('EMPTY')
        }
      } else {
        setContractData(null)
        setContractStatus('EMPTY')
        setLocationsStatus('EMPTY')
        setDeliveryStatus('EMPTY')
        setSignersStatus('EMPTY')
      }
    })
      .catch(err => {
        console.error(err)
      })
  }, [contract_id])

  useEffect(() => {
    callGetContractById()
  }, [callGetContractById])

  useEffect(() => {
    if (contract_id) {
      getScaleTickets(contract_id, 'external_reference_id')
      getStewardshipActivities(contract_id)
    }
  }, [contract_id, getScaleTickets, getStewardshipActivities])

  useEffect(() => {
    if (companiesArray.length) {
      if (hasAccess(companiesArray, 'void-contract') === 'SUCCESS') {
        setHasPermissions('SUCCESS')
      }
    }
  }, [companiesArray, hasAccess])

  useEffect(() => {
    if (!canceled.current || stewardsUsers) {
      const access = hasAccess(companiesArray, 'is-steward')
      const accessAll = hasAccess(companiesArray, 'all-steward')
      const createContract = hasAccess(companiesArray, 'create-contract')
      const signContract = hasAccess(companiesArray, 'sign-contract')
      const voidContract = hasAccess(companiesArray, 'void-contract')
      const approveContract = hasAccess(companiesArray, 'approve-contract')
      const amendContract = hasAccess(companiesArray, 'amend-contract')
      const deleteVoid = hasAccess(companiesArray, 'delete-void')
      const isUserSteward = hasStewardAccess(stewardsUsers || [])

      if (access === 'SUCCESS' || accessAll === 'SUCCESS' || isUserSteward === 'SUCCESS'
        || createContract === 'SUCCESS'
        || signContract === 'SUCCESS'
        || voidContract === 'SUCCESS'
        || approveContract === 'SUCCESS'
        || amendContract === 'SUCCESS'
        || deleteVoid === 'SUCCESS'
      ) {
        setHasStewardshipPermissions('SUCCESS')
      } else if (!access) {
        setHasStewardshipPermissions()
      }
    }
  }, [companiesArray, hasAccess, hasStewardAccess, stewardsUsers])

  useEffect(() => {
    if (
      contractData.contract_state &&
      contractData.contract_state === 'voided'
    ) {
      setIsVoided(true)
    }
  }, [contractData.contract_state])

  useEffect(() => {
    let tempObj = {}
    let sapObj = {}
    let idObj = {}
    if (contractData) {
      tempObj.created = moment(contractData.created).format('MMMM Do YYYY, h:mm:ss a')
      tempObj.year = moment(contractData.contract_start_execution).format(
        'YYYY'
      )
      sapObj.growerSAPId = contractData.contract_details?.grower_details.sap_id
      sapObj.resellerSAPId = contractData.contract_details?.reseller_details.sap_id
      idObj.resellerId = contractData.contract_details?.reseller_details.reseller_id
      idObj.receiverId = contractData.contract_details?.grain_receiver_details.grain_receiver_id
      if (contractData.contract_details) {
        tempObj.contract_type = convertToSentenceCase(
          contractData.contract_details.display_details.contract_type
        )
        tempObj.reseller = nullParser(
          contractData.contract_details.reseller_details.reseller_name
        )
        tempObj.enogen_units = enogenUnitsCalculator(
          contractData.contract_details.fields,
          contractData.contract_details.display_details.contract_type
        )
        tempObj.grain_receiver = nullParser(
          contractData.contract_details.grain_receiver_details
            .grain_receiver_name
        )
        if (contractData.contract_details.grower_details) {
          const temp = contractData.contract_details.grower_details
          tempObj.grower_name = `${temp.first} ${temp.last}`
        }
        if (contractData.contract_details.fields) {
          const temp = contractData.contract_details.fields
          if (temp.length > 1) {
            const fieldIndex = temp.findIndex(filedData => {
              return (filedData?.is_total !== undefined && filedData?.is_total === true)
            })
            if (fieldIndex !== -1) {
              temp.splice(fieldIndex, 1)
            }
          }
          let totalAcres = 0
          temp.forEach(field => {
            totalAcres = totalAcres + Number(field.acres)
          })
          tempObj.acres = totalAcres.toFixed(2)
        }
        if (contractData.contract_details.fields) {
          let temp = contractData.contract_details.fields
          let totalYield = 0
          temp.forEach(field => {
            totalYield += Number(field.acres) * Number(field.average_yield)
          })
          tempObj.total_yield = Math.round(totalYield)
        }
        if (contractData.contract_originated && contractData.contract_originated !== null)
          tempObj.contract_originated = contractData.contract_originated
        else
          tempObj.contract_originated = 'GrowMore360'
      }
      if (contractData.contract_history) {
        setContractHistoy(contractData.contract_history)
      }
    }
    setGrowerAndResellerSAP(sapObj)
    setResellerAndReceiverId(idObj)
    setContractDetailData(tempObj)

  }, [contractData])

  useEffect(() => {
    const formatDeliveryData = (contractYear, contractDeliverySchedule, _stewardshipData, _scaleTickets) => {
      const finalArray = []
      let harvestTotal = 0
      let deliveredTotal = 0
      let contractTotal = 0
      const monthMap = generateMonthMap(contractYear)
      _stewardshipData.forEach(field => {
        const harvest = field?.activity?.harvest
        if (harvest?.harvest_date) {
          harvestTotal += stringToFloat(harvest.total_harvest)
        }
      })
      contractDeliverySchedule.forEach(field => {
        const { contract_units } = field
        contractTotal += stringToFloat(contract_units)
      })
      _scaleTickets.forEach(scaleTicket => {
        deliveredTotal += scaleTicket.net_quantity ? stringToFloat(scaleTicket.net_quantity) : 0
      })
      contractDeliverySchedule.forEach((contractMonth, index) => {
        const delivery_month = `${convertToSentenceCase(contractMonth.delivery_month.substring(0, 3))}-${contractMonth.delivery_year.toString().substring(2, 4)}`
        const currentMonth = { ...monthMap.get(delivery_month) }
        const contracted_units = stringToFloat(contractMonth.contract_units)
        const harvested_units = Math.round((contracted_units / contractTotal) * harvestTotal)
        let delivered_units = 0
        if (harvested_units) {
          if (harvested_units <= deliveredTotal) {
            if (index === contractDeliverySchedule.length - 1) {
              delivered_units = deliveredTotal
              deliveredTotal -= harvested_units
            } else {
              delivered_units = harvested_units
              deliveredTotal -= harvested_units
            }
          } else {
            delivered_units = deliveredTotal
            deliveredTotal = 0
          }
        }
        monthMap.set(delivery_month, {
          ...currentMonth,
          delivery_month,
          contracted_units,
          harvested_units: harvested_units,
          delivered_units
        })
      })

      monthMap.forEach((value, key) => {
        finalArray.push(value)
      })
      setFuelDeliveryTableStatus()
      setDeliveryData(finalArray)
    }
    if (contractData?.contract_details?.delivery_schedule && stewardshipData && scaleTickets) {
      const stewardshipActivities = stewardshipData.length ? stewardshipData[0].stewardship_activity.fields : []
      const contractYear = moment(contractData.contract_start_execution).format('YYYY')
      const containsZeroOut = scaleTickets.filter(ticket => ticket.scale_ticket_id.includes('zeroout'))
      formatDeliveryData(contractYear, contractData?.contract_details?.delivery_schedule, stewardshipActivities, scaleTickets)
      if (containsZeroOut.length > 0) {
        setIsZeroOut(true)
      }
    }
  }, [scaleTickets, contractData, stewardshipData])

  const handleSyncContract = () => {
    setSynBtnTxt('Sync in progress...')
    syncContract(contract_id, contractData.docusign_envelope_id).then(res => {
      if (res.status === 200) {
        setTimeout(() => {
          setSynBtnTxt('Sync Complete')
        }, 60000)
      }
      else {
        setSynBtnTxt('Sync Failed')
      }
    })
  }

  const signContractButton = (
    <a href={`/contracts/sign-pdf/${contract_id}`} onClick={goToSignContract}>
      <Button>Sign contract</Button>
    </a>
  )

  const resendForSigningButton = (
    <a href={`/contracts/sign-pdf/${contract_id}`} onClick={goToResendForSigning}>
      <Button>Resend for signing</Button>
    </a>
  )

  let voidContractButton = null
  const buttonArray = []

  if (isSyncContract) {
    buttonArray.push(
      <Button
        key='success'
        text={synBtnTxt}
        customClassName="mr10"
        styleType="success"
        onClick={handleSyncContract}
        disabled={synBtnTxt !== 'Sync contract'}
      />
    )
  }

  if (hasPermissions === 'SUCCESS') {
    if (isVoided) {
      buttonArray.push(
        <Button key="void" disabled>
          Contract voided
        </Button>
      )
    } else {
      isAmend && buttonArray.push(
        <Button
          key="ammend"
          customClassName="mr10"
          styleType="success"
          onClick={attemptAmendContract}
        >
          Amend contract
        </Button>
      )
      buttonArray.push(
        <span
          className={scaleTickets?.length > 0 && 'custom-tooltip'}
          message='This contract cannot be voided because it has associated scale tickets'
        >
          <Button
            key="void"
            styleType="success"
            onClick={attemptVoidContract}
            disabled={scaleTickets?.length > 0}
          >
            Void contract
          </Button>
        </span>
      )
    }
  }
  if (hasStewardshipPermissions === 'SUCCESS' && stewardshipData?.length && showRecordStewardship) {
    buttonArray.push(
      <a
        key="stewardship"
        href={`/company/${company_id}/stewardship/${stewardshipData[0].stewardship_activity_id}`}
        onClick={goToStewardship}
      >
        <Button customClassName="ml10" styleType="success">
          Record Stewardship
        </Button>
      </a>
    )
  }
  if (buttonArray.length) {
    voidContractButton = <div>{buttonArray}</div>
  }

  let content = (
    <>
      <p className="w100%">
        Are you sure you want to permanently void the following contract?
      </p>
      <p className="w100%">{`"${state?.detailView?.title}"`}</p>
    </>
  )
  let bottomRow = (
    <>
      <Button onClick={handleClose}>Cancel</Button>
      <div data-testid={'actuallyVoidContractButton'}>
        <Button
          styleType="error"
          onClick={() => actuallyVoidContract('void')}
          customClassName="ml10 mr10"
        >
          Void contract
        </Button>
      </div>
    </>
  )

  let modalTitle = 'Void contract'

  if (modalState === 'AMEND') {
    modalTitle = 'Amend contract'
    if (isVoided) {
      content = (
        <>
          <p className="w100%">
            This contract is already voided. Amending will permit you to create
            a new contract with the original values.
          </p>
          <p className="w100%">Are you sure you want to continue?</p>
        </>
      )
      bottomRow = (
        <>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            styleType="success"
            onClick={() => handleClose('AMEND')}
            customClassName="ml10 mr10"
          >
            Continue
          </Button>
        </>
      )
    } else {
      content = (
        <>
          <p className="w100%">
            {contractData?.contract_language === 'en' ? 'Amending this contract will allow field, feeding and delivery changes. You cannot edit the Grower or Reseller associated to this contract by an amendment. Are you ready to Amend this contract?'
              : 'La modification de ce contrat permet d\'apporter des changements au niveau du champ, du type d\'alimentation et de la livraison. Vous ne pouvez cependant pas modifier le producteur ou le détaillant associé à ce contrat par le biais de la modification. Une fois que vous avez commencé une modification, le contrat original est annulé et le processus de modification doit être complété. Etes-vous certain de vouloir continuer?'}
          </p>
        </>
      )
      bottomRow = (
        <>
          <Button onClick={handleClose}>Cancel</Button>
          <div data-testid={'submitAmendContractButton'}>
            <Button
              styleType="success"
              onClick={() => actuallyVoidContract('amend')}
              customClassName="ml10 mr10"
            >
              Amend
            </Button>
          </div>
        </>
      )
    }
  }

  switch (loadingStatus) {
    case 'SUCCESS':
      content = <p className="w100%">Contract successfully voided.</p>
      if (modalState === 'AMEND') {
        bottomRow = (
          <div data-testid="confirmAmendingButton">
            <Button
              styleType="success"
              onClick={() => handleClose('AMEND')}
              customClassName="ml10 mr10 mb10"
            >
              Continue to amend
            </Button>
          </div>
        )
      } else {
        bottomRow = (
          <Button
            styleType="success"
            onClick={() => handleClose('SUCCESS')}
            customClassName="ml10 mr10"
          >
            Close
          </Button>
        )
      }
      break
    case 'LOADING':
      bottomRow = (
        <Button
          disabled
          styleType="success"
          onClick={() => handleClose('SUCCESS')}
          customClassName="ml10 mr10"
        >
          Close
        </Button>
      )
      break
    case 'FAILED':
      content = (
        <p className="w100%">
          Something went wrong. Please contact your admin.
        </p>
      )
      bottomRow = (
        <Button
          styleType="success"
          onClick={handleClose}
          customClassName="ml10 mr10"
        >
          Close
        </Button>
      )
      break
    default:
      break
  }

  const [stewardshipStatus, setStewardshipStatus] = useState('LOADING')
  const [replantOrLost, setReplantOrLost] = useState([])
  const [stewardshipSummaryDataArray, setStewardshipSummaryDataArray] = useState([])
  const [cleanoutSummaryData, setCleanoutSummaryData] = useState([
    {
      complete: 'Complete',
      planting_summary: null,
      harvest_summary: null,
      storage_summary: null
    }
  ])
  // const plantingSummaryHandler = (arg1, arg2) => {
  //   let counter = 0
  //   if (arg1) {
  //     counter++
  //   }
  //   if (arg2) {
  //     counter++
  //   }
  //   if (counter === 2) {
  //     return true
  //   } else if (counter === 1) {
  //     return false
  //   }
  //   return null
  // }

  const stewardshipSummaryHelper = (arr, type, maxEmptyStrings) => {
    return arr.map(obj => {
      let emptyStringCount = 0
      let result = true
      let resultObj = {
        name: obj.name
      }
      for (const prop in obj) {
        if (obj[prop] === '') {
          emptyStringCount++
        }
      }
      if (emptyStringCount === maxEmptyStrings) {
        result = null
      } else if (emptyStringCount < maxEmptyStrings && emptyStringCount > 0 && obj.is_silage_harvest !== true) {
        result = false
      }
      resultObj[type] = result
      return resultObj
    })
  }

  const MAX_FALSEY_PLANTING_VALUES = 4
  const MAX_FALSEY_HARVEST_VALUES = 6

  const setWidgetData = useCallback(res => {
    setReplantOrLost(res.activities.fields)
    setStewardsUsers(res?.stewardData)

    const plantingSummaryArray = stewardshipSummaryHelper(res.plantingData, 'planting', MAX_FALSEY_PLANTING_VALUES)
    const harvestSummaryArray = stewardshipSummaryHelper(res.harvestData, 'harvest', MAX_FALSEY_HARVEST_VALUES)
    let stewardshipSummary = plantingSummaryArray.map((item, i) => Object.assign({}, item, harvestSummaryArray[i]))
    setStewardshipSummaryDataArray(stewardshipSummary)
    if (isTotalfield) {
      setStewardshipSummaryDataArray([])
    }
    const storageDataResultArray = res.storageData.map(obj => {
      if (obj.cleanout_date !== '' && obj.capacity > 0) {
        return true
      } else if (obj.cleanout_date !== '' || obj.capacity > 0) {
        return false
      } else {
        return null
      }
    })
    let storageSummary = false
    if (storageDataResultArray.every(val => val === true)) {
      storageSummary = true
    } else if (storageDataResultArray.every(val => val === null)) {
      storageSummary = null
    }
    setCleanoutSummaryData(prev => [
      {
        ...prev[0],
        harvest_summary: res.originalResponse?.data.harvest_status === 'Complete' ? true : res.originalResponse?.data.harvest_status === 'In Progress' ? false : null,
        planting_summary: res.originalResponse?.data.planting_status === 'Complete' ? true : res.originalResponse?.data.planting_status === 'In Progress' ? false : null,
        storage_summary: storageSummary
      }
    ])
  }, [isTotalfield])

  const getStewardshipFieldsCall = useCallback(() => {
    const stewardship_activity_id = stewardshipData ? stewardshipData[0]?.stewardship_activity_id : null
    if (stewardship_activity_id) {
      getStewardshipFields(stewardship_activity_id)
        .then(res => {
          if (res) {
            if (res.activities.fields.length === 1 && (res.activities.fields[0].field_id === 'total_enogen_acres_id' || res.activities.fields[0].field_id === 'TotalEnogenAcres')) {
              setIsTotalfield(true)
            }
            setWidgetData(res)
            setStewardshipStatus(null)
          } else {
            setStewardshipStatus()
          }
        })
    } else {
      setStewardshipStatus(null)
    }
  }, [setWidgetData, stewardshipData])

  const handleResend = async (
    growerPhone,
    growerEmail,
    growerDeliveryChoice,
    contract,
    contract_signer_id
  ) => {
    try {
      setResendLoading('LOADING')
      const result = await changePhoneAndResend(
        growerPhone,
        growerEmail,
        growerDeliveryChoice,
        contract.contract_id,
        contract_signer_id
      )

      if (result?.data?.error) {

        console.error('Error when resending for signing:', result.data.error)
        setResendMessage('Error when resending for signing, Please try again later.')
        setResendLoading('ERROR')
        return
      }
      setResendLoading('SUCCESS')
      const contractData = await getContractByIdWithInitialField(contract_id)
      if (contractData?.contract_signers) {
        setSignersData(handleSigners(contractData.contract_signers))
      }
    } catch (err) {

      const msg = err.message || 'Error when resending for signing, Please try again later.'
      console.error(msg, err)
      setResendMessage('Error when resending for signing, Please try again later')
      setResendLoading('ERROR')
    }
  }

  useEffect(() => {
    getStewardshipFieldsCall()
  }, [getStewardshipFieldsCall])

  const growerDetails = contractData && contractData.contract_details && contractData.contract_details.grower_details ?
    contractData.contract_details.grower_details : {}
  const resellerDetails = contractData && contractData.contract_details && contractData.contract_details.reseller_details ?
    contractData.contract_details.reseller_details : {}
  const grainReceiverDetails = contractData && contractData.contract_details && contractData.contract_details.grain_receiver_details ?
    contractData.contract_details.grain_receiver_details : {}
  let growerSigner = contractData && contractData.contract_signers && contractData.contract_signers.filter(c => c.role === 'grower')[0]

  if (!growerSigner) {
    growerSigner = contractData && contractData.contract_signers && contractData.contract_signers.filter(c => c.external_reference_id === growerDetails.sap_id)[0]
  }
  if (!growerSigner) {
    growerSigner = contractData && contractData.contract_signers && contractData.contract_signers.filter(c => c.phone === growerDetails.phone)[0]
    if (!growerSigner && growerDetails?.phone) {
      // eslint-disable-next-line no-console
      console.log(`\n\nCannot identify Grower Signer in the contract signers array because there is no match on sap_id or phone: \n\n Grower Details ${JSON.stringify(growerDetails)} \n\n Contract Signers: ${JSON.stringify(contractData.contract_signers)}\n\n`)
    }
  }
  const growerApproved = growerSigner && growerSigner.approval_timestamp
  return (
    <DetailView button={voidContractButton} contract_id={contract_id} isVoided={isVoided} modifiedDate={modifiedDate} previousPage="contractDetail">
      <>

        <ContractDetailWidget
          company_id={company_id}
          contractData={contractDetailData}
          contractHeaders={contractData.contract_type === 'non-enogen' ? contractDetailGenericSubHeaders : contractDetailSubHeaders}
          status={contractStatus}
          contract_id={contractData?.contract_id}
          contract_doc_link={contractData?.contract_doc_link}
          isVoided={isVoided}
          growerAndResellerSAP={growerAndResellerSAP}
          resellerAndReceiverId={resellerAndReceiverId}
          contract_state={contractData?.contract_state}
        />
        {contractType === FUEL ?
          <FuelDeliveryWidget
            data={deliveryData}
            status={fuelDeliveryTableStatus}
            growerName={contractDetailData.grower_name}
            contract_year={contractData.contract_start_execution}
            external_reference_id={contractData?.contract_id}
            isZeroOut={isZeroOut}
          />
          :
          <DeliveryCard
            data={
              contractType === FED_ON_FARM
                ? contractData?.contract_details?.cattle_info
                : contractData?.contract_details?.delivery_schedule
            }
            isFedOnFarm={contractType === FED_ON_FARM}
            status={deliveryStatus}
            contract_year={contractData.contract_start_execution}
            class_name={contractType === 'generic' ? 'tab_display_none' : ''}
          />
        }
        <ContractHistoryWidget
          contractHistoryData={contractHistoy}
          contractState={contractData?.contract_state}
          status={contractStatus}
          contractOriginated={contractDetailData.contract_originated}
          contractStartDate={contractData.created}
        />
        <ModalWithStates
          handleClose={handleClose}
          showModal={showModal}
          content={content}
          title={modalTitle}
          bottomRow={bottomRow}
          loading={loadingStatus === 'LOADING'}
          loadingPrompt="Please wait. Voiding contract."
          dataTestId={'generalContractDetailViewModal'}
        />

        {Object.keys(growerDetails).length !== 0 &&
          <>
            <div className="modalContainer" style={{ display: showSignersModal ? 'block' : 'none' }}>
              <div className="aHModalChild posr t100" style={{ 'maxWidth': '900px' }}>
                <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
                  <SendForSigningForm
                    setShowModal={setShowSignersModal}
                    contractData={contractData}
                    growerDetails={growerDetails}
                    growerSigner={growerSigner}
                    resellerDetails={resellerDetails}
                    grainReceiverDetails={grainReceiverDetails}
                    resend={true}
                    handleResend={handleResend}
                    resendLoading={resendLoading}
                    resendMessage={resendMessage}
                    setResendLoading={setResendLoading}
                  />
                </div>
              </div>
            </div>
          </>
        }

      </>
      <>
        <SignersAndApprovers
          data={signersData}
          status={signersStatus}
          button={isVoided ? null : !growerApproved && contractData && (contractData.contract_state === 'pending' || contractData.contract_state === 'amendment_pending') ?
            resendForSigningButton : signContractButton}
          company_id={company_id}
          isVoided={isVoided}
          contractOriginated={contractDetailData.contract_originated}
        />
        <LocationsWidget
          data={
            contractData &&
            contractData.contract_details &&
            contractData.contract_details.storage
          }
          status={locationsStatus}
        />
        <StewardshipSummary
          status={stewardshipStatus}
          completeStatus={stewardshipStatus}
          data={stewardshipSummaryDataArray}
          replantOrLost={replantOrLost}
          completeData={cleanoutSummaryData}
        />
      </>
    </DetailView>
  )
}

export default ContractDetailView